// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-releaseReloadModule[data-v-361ee960] .v-snack__wrapper{background:var(--teampulse-gradient);margin:24px}.m-releaseReloadModule--mobile[data-v-361ee960] .v-snack__wrapper{margin:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
